import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Warranty } from '../models/warranty.model';
import { ContratoLocacionDTO } from '../models/location-contract';

@Injectable({
  providedIn: 'root'
})
export class ContratoLocacionService {

  private apiUrl = `${environment.apiUrl}/contrato/locacion`;

  constructor(private http: HttpClient) { }

  /**
   * Genera vista previa del contrato de locación
   */
  generatePreview(guaranteeId: number, contractData: ContratoLocacionDTO): Observable<Blob> {
    const url = `${this.apiUrl}/${guaranteeId}/vista-previa`;
    const params = new HttpParams().set('pdf', 'true');

    return this.http.post(url, contractData, {
      params: params,
      responseType: 'blob',
      headers: {
        'Accept': 'application/pdf'
      }
    });
  }

  /**
   * Genera vista previa demo (sin garantía)
   */
  generatePreviewDemo(contractData: ContratoLocacionDTO): Observable<Blob> {
    const url = `${this.apiUrl}/vista-previa-demo`;
    
    return this.http.post(url, contractData, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/pdf'
      }
    });
  }

  /**
   * Confirma el contrato de locación
   */
  confirmContract(guaranteeId: number, contractData: ContratoLocacionDTO): Observable<ContratoLocacionDTO> {
    const url = `${this.apiUrl}/${guaranteeId}/confirmar`;
    
    return this.http.post<ContratoLocacionDTO>(url, contractData);
  }

  /**
   * Convierte número a texto (helper method)
   */
  convertNumberToWords(amount: number): Observable<string> {
    // Si tienes un endpoint en el backend para esto
    return this.http.get<string>(`${environment.apiUrl}/utils/number-to-words`, {
      params: { amount: amount.toString() }
    });
  }

  /**
   * Valida CBU (helper method)
   */
  validateCBU(cbu: string): boolean {
    // Validación básica de CBU argentino (22 dígitos)
    return /^\d{22}$/.test(cbu);
  }

  /**
   * Valida CUIT (helper method)
   */
  validateCUIT(cuit: string): boolean {
    // Validación básica de CUIT argentino
    const cleanCuit = cuit.replace(/[-]/g, '');
    return /^\d{11}$/.test(cleanCuit);
  }
}